module.exports = __webpack_public_path__ + "fonts/01f7991117cc694055ee539adcccee84.txt";